import React, { CSSProperties, useEffect, useRef } from 'react';
import gsap from 'gsap';

type LeaveConfirmPopoverProps = {
  isWaitlistOnly: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Shared "Leave / Stay" confirm bar — extracted out of ExitTableButton so its
// JSX/styles live in one place.
const LeaveConfirmPopover = ({ isWaitlistOnly, onConfirm, onCancel }: LeaveConfirmPopoverProps) => {
  const confirmRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (confirmRef.current) {
      gsap.fromTo(
        confirmRef.current,
        { opacity: 0, x: 8 },
        { opacity: 1, x: 0, duration: 0.2, ease: 'power2.out' }
      );
    }
  }, []);

  return (
    <div ref={confirmRef} style={confirmBar}>
      <span style={confirmText}>{isWaitlistOnly ? 'Exit waitlist?' : 'Exit table?'}</span>
      <button onClick={onConfirm} style={confirmYes}>
        Leave
      </button>
      <button onClick={onCancel} style={confirmNo}>
        Stay
      </button>
    </div>
  );
};

export default LeaveConfirmPopover;

// Saloon confirm popover (no backdrop-filter — perf guide). The "Leave"
// affirmative keeps the burnt-rust danger accent.
const confirmBar: CSSProperties = {
  position: 'absolute',
  right: '100%',
  top: '50%',
  transform: 'translateY(-50%)',
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem',
  padding: '0.35rem 0.5rem',
  background: 'linear-gradient(180deg, #1a2438, #0a1322)',
  border: '1px solid rgba(232,130,31,0.35)',
  borderRadius: '6px',
  boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.55)',
  whiteSpace: 'nowrap',
  zIndex: 30
};

const confirmText: CSSProperties = {
  fontSize: '0.75rem',
  color: '#d9c79e',
  fontWeight: 500
};

const confirmYes: CSSProperties = {
  background: 'linear-gradient(180deg, #c9332a, #6b1a14)',
  border: '1px solid #2a0805',
  borderRadius: '5px',
  color: '#f1e3c7',
  fontSize: '0.7rem',
  fontWeight: 700,
  padding: '0.3rem 0.6rem',
  cursor: 'pointer',
  fontFamily: 'inherit',
  minHeight: '28px'
};

const confirmNo: CSSProperties = {
  background: 'rgba(20,30,48,0.85)',
  border: '1px dashed rgba(232,130,31,0.45)',
  borderRadius: '5px',
  color: '#d9c79e',
  fontSize: '0.7rem',
  fontWeight: 600,
  padding: '0.3rem 0.6rem',
  cursor: 'pointer',
  fontFamily: 'inherit',
  minHeight: '28px'
};
